import { store } from '../../../src/store';
import {createApp} from 'vue'


if(document.querySelector('.c-info-bar__container')){
	var app_courses_module = createApp({
		data(){
			return {
				hidden: true
			}
		},
		computed: {
			clientLogged(){
				return store.getters['account/clientLogged']
			}
		},
		mounted(){
			if (!this.clientLogged) {
				this.hidden = false;
			}
		},
		methods:{
			hideBar: function(){
				this.hidden = true;
			}
		}
	}).mount(document.querySelector('.c-info-bar__container'));
} 